import roles from './roles';

/**
 * Papéis com acesso a qualquer rota do painel (/painel/*).
 * Clientes finais (USER) e garçons (WAITER) ficam de fora e são
 * redirecionados para a listagem pública de eventos.
 */
export const DASHBOARD_ROLES = [roles.PRODUCER, roles.ESTABLISHMENT, roles.ADMIN];

/** Papéis com acesso ao painel do produtor (/painel/produtor/*). */
export const PRODUCER_ROLES = [roles.PRODUCER, roles.ESTABLISHMENT, roles.ADMIN];

/** Papéis com acesso ao painel do estabelecimento (/painel/estabelecimento/*). */
export const ESTABLISHMENT_ROLES = [roles.ESTABLISHMENT, roles.ADMIN];

export function hasRole(user, allowedRoles) {
    return allowedRoles.some((role) => role == user?.role?.id);
}

export function canAccessDashboard(user) {
    return hasRole(user, DASHBOARD_ROLES);
}

/**
 * A pessoa de verdade tem painel próprio? Dentro do painel de um produtor
 * `user` é o produtor, então quem vale é o membro que entrou por ele.
 */
export function actorHasOwnPanel(user) {
    const roleId = user?.acting_as ? user.acting_as.member?.role_id : user?.role?.id;

    return hasRole({ role: { id: roleId } }, DASHBOARD_ROLES);
}
